import { iaRa } from 'lib/helpers/utility';

export const checkActiveItem = (switchItems, view, location, type) => {
  const selectedItem = iaRa(switchItems).find((item) => {
    if (view) {
      return item.value === view;
    }

    if (type) {
      return item.type === type;
    }

    return item.navigate === location.pathname || null;
  });

  return selectedItem;
};
